export default __webpack_public_path__ + "static/media/background_alt.479cfd01.png";